import FicheroInspeccionClass from "./ficheroInspeccionClass"
import GruposClass from "./gruposClass"

export default class InspeccionClass {
    public LocalId: number
    public Id: number
    public Codigo: string
    public NumOferta: string
    public NumPedido: string
    public NumInforme: string
    public Inspeccion: string
    public FechaInicio: string
    public FechaFin: string
    public Email: string
    public Telefono: string
    public ListaGrupos: GruposClass[]
    public StartupRan: boolean
    public AreaId: number
    public Area: string
    public UploadFotosToken: string
    public NombreCliente: string
    public ListaFicheros: FicheroInspeccionClass[]
    public DireccionEmplazamiento: string
    public OtraInformacion: string
    public Descargada?: boolean = false
    public AlgunDocumentoGenerado?: boolean = false
    public AlgunDocumentoFirmado?: boolean = false
    public DescartadaPorElTecnico?: boolean = false
    public Selected: boolean = false
    public NoGuardadoServidor: boolean = false
    public SeHaAplicadoLaLogica: boolean = true
    public SePuedeSaltarLogica: boolean = false
    public ListaParametrosConImg: string[]
    public FirmaConformidadNoGuardada: boolean = false
    public FirmaConservadorNoGuardada: boolean = false
    public FirmaInspectorNoGuardada: boolean = false
    public Expediente: string
    public MotivoDescarte: string
}